import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { BrandingSettingsPage } from '@/pages/settings/organization/BrandingSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/branding/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <BrandingSettingsPage />
    </RoleGate>
  )
}
